import styled from "styled-components";

const StyledSelectListField = styled.div`
  ${({ theme }) => theme.components.SelectListField?.customCss}
`;

export default StyledSelectListField;
